import React from 'react';
import {YoutubeVideos} from './youtube-videos';

export const YoutubeVideosPage = (props: any) => {
  return <YoutubeVideos {...props} />;
};
